/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AddServiceContact } from './AddServiceContact';
import {
	AddServiceContactFromJSON,
	AddServiceContactFromJSONTyped,
	AddServiceContactToJSON,
} from './AddServiceContact';

/**
 * A payload that will add multiple service contacts to a client organization.
 * @export
 * @interface BulkAddServiceContact
 */
export interface BulkAddServiceContact {
	/**
	 *
	 * @type {Array<AddServiceContact>}
	 * @memberof BulkAddServiceContact
	 */
	serviceContacts?: Array<AddServiceContact>;
}

/**
 * Check if a given object implements the BulkAddServiceContact interface.
 */
export function instanceOfBulkAddServiceContact(value: object): boolean {
	let isInstance = true;

	return isInstance;
}

export function BulkAddServiceContactFromJSON(json: any): BulkAddServiceContact {
	return BulkAddServiceContactFromJSONTyped(json, false);
}

export function BulkAddServiceContactFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): BulkAddServiceContact {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		serviceContacts: !exists(json, 'serviceContacts')
			? undefined
			: (json['serviceContacts'] as Array<any>).map(AddServiceContactFromJSON),
	};
}

export function BulkAddServiceContactToJSON(value?: BulkAddServiceContact | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		serviceContacts:
			value.serviceContacts === undefined
				? undefined
				: (value.serviceContacts as Array<any>).map(AddServiceContactToJSON),
	};
}
